{
  "checkout": {
    "backToCart": "Volver al carrito"
  },
  "checkoutProgress": {
    "label": "Progreso de la compra",
    "deliveryAddress": "Delivery Address",
    "deliveryMode": "Modo de entrega",
    "paymentDetails": "Pago",
    "reviewOrder": "Revisar",
    "billingAddress": "Billing Address"
  },
  "checkoutAddress": {
    "shippingAddress": "Dirección de envío",
    "selectYourDeliveryAddress": "Seleccione su dirección de entrega",
    "defaultDeliveryAddress": "Dirección de entrega predeterminada",
    "addNewAddress": "Agregar nueva dirección",
    "shipToThisAddress": "Enviar a esta dirección",
    "deliveryAddressSelected": "Dirección de entrega seleccionada"
  },
  "checkoutMode": {
    "deliveryMethod": "Método de entrega",
    "standardDelivery": "Entrega estándar",
    "premiumDelivery": "Entrega premium",
    "deliveryEntries": "Artículos para enviar"
  },
  "checkoutReview": {
    "review": "Revisar",
    "orderItems": "Artículos del pedido",
    "confirmThatRead": "He leido y acepto los",
    "placeOrder": "Realizar pedido",
    "termsAndConditions": "Términos y condiciones",
    "editDeliveryAddressDetails": "Editar detalles de la dirección de entrega, abre la página de Dirección de entrega",
    "editPaymentDetails": "Editar detalles de pago, abre la página de Detalles de pago",
    "editPaymentType": "Editar método de pago, abre la página de Método de pago",
    "editDeliveryMode": "Editar modo de entrega, abre la página de Modo de entrega",
    "orderInProcess": "El pedido está en proceso. Por favor espera."
  },
  "checkoutOrderConfirmation": {
    "confirmationOfOrder": "Confirmación de pedido:",
    "thankYou": "¡Gracias por tu pedido!",
    "invoiceHasBeenSentByEmail": "Se ha enviado una factura por correo electrónico. Deberías recibirla pronto.",
    "orderItems": "Artículos del pedido",
    "orderPlacedSuccessfully": "Pedido realizado con éxito",
    "createAccount": "¿Crear una cuenta?",
    "createAccountForNext": "Crea una cuenta para <{{email}}> para un proceso de compra más rápido en tu próxima visita."
  }
}